import { getMrqData, getMrqPos } from "../../api";
import { getMrqBid } from "../api";
import { getBidTableRows } from "../BidTable/BidTableBody/getRows";

export const fetchMrqThenBidData = async ({
  plant,
  mrqSelection,
  setBidData,
  setBidTableRows,
  setSelectedBidMrqData,
}) => {
  console.log("after selected mrq plant: ---------------------", plant);
  if (mrqSelection.selectedMrq) {
    const mrq = await getMrqData(
      mrqSelection.selectedRevision || mrqSelection.selectedMrq,
    );

    const bids = await getMrqBid(
      mrqSelection.selectedRevision || mrqSelection.selectedMrq,
    );
    const existedPos = await getMrqPos(
      mrqSelection.selectedRevision || mrqSelection.selectedMrq,
    );
    setBidData(bids ? bids : []);
    // console.log({ mrqData, bids });
    // setBidTableRows([]);

    setBidTableRows(
      getBidTableRows({
        mrqData: mrq, //? plant.selectedBidMrq : {},
        bidData: bids ? bids : [],
        existedPos,
        plant,
      }),
    );

    setSelectedBidMrqData({
      ...mrq,
      BidTableRows: getBidTableRows({
        mrqData: mrq,
        bidData: bids ? bids : [],
        existedPos,
        plant,
      }),
    });
  }
};
